module.exports = __webpack_public_path__ + "media/images/desktop/survey-d011d284076a4b1a2255f9065dbbaa4f.svg";